import React from 'react';
import { Chip } from '@mui/material';

export type ChipColors = 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';

type ChipSizes = 'small' | 'medium';

interface ChipProps {
  label: string;
  labelColorMap: Record<string, ChipColors>;
  onClick?: () => void;
  dataTestId?: string,
  size?: ChipSizes,
  chipStyles?: {
    width?: number
  }
}

const ChipComponent = ({ label, labelColorMap, onClick, chipStyles, size, dataTestId }: ChipProps) => {
  return (
    <Chip
      label={label}
      color={labelColorMap[label] || 'default'}
      size={size}
      onClick={onClick}
      sx={chipStyles}
      data-testid={dataTestId}
    />
  );
};

export { ChipComponent };
